import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface FilesPickerItemProps {
  name: string;
  status: 'uploading' | 'complete' | 'failed' | 'pending';
}

function FilesPickerItem({name, status}: FilesPickerItemProps): JSX.Element {
  return (
    <td>
      <span className="pull-right">
        {status === 'uploading' ? (
          <img src="/static/img/spinner.gif" />
        ) : status === 'complete' ? (
          <span className="glyphicon glyphicon-ok" />
        ) : status === 'failed' ? (
          <span className="glyphicon glyphicon-exclamation-sign" />
        ) : status === 'pending' ? (
          <span className="glyphicon glyphicon-trash delete u-danger-pointer" />
        ) : null}
      </span>
      <span className="name">
        <span className="glyphicon glyphicon-file files-picker-icon" />
        <span {...getTestProps({component: 'FilesPickerItem', element: 'fileName'})}>{name}</span>
      </span>
    </td>
  );
}

export default makeDeprecatedJadeStyleTemplate<FilesPickerItemProps>(FilesPickerItem);
